module.exports = __webpack_public_path__ + "assets/img/btn-info-559fa598.png";